// @flow
import styled from 'styled-components';

import Button from 'components/shared/button';

import { CLARK_TERTIARY } from 'styles/colors';
import { FONT_WEIGHT_100 } from 'styles/font-weight';
import { SPACING_LARGE } from 'styles/spacing';
import { BORDER_WIDTH_1 } from 'styles/borders';

export const PlaidButton = styled<any>(Button)`
  max-width: inherit;
  width: 100%;
  margin-bottom: ${SPACING_LARGE};
`;

export const PlaidTextLink = styled.span`
  ${FONT_WEIGHT_100};
  border-bottom: ${BORDER_WIDTH_1} dotted ${CLARK_TERTIARY};
  color: ${CLARK_TERTIARY};
  text-decoration: none;
  cursor: pointer;
  width: auto;
`;



// WEBPACK FOOTER //
// ./src/components/plaid-link/styles.js